import React, { useState, useRef, useEffect } from "react";
import { Send } from "lucide-react";
import { useTranslation } from "react-i18next";
import { sanitizeInput } from "@/utils/helpers";
import { INPUT_LIMITS } from "@/utils/constants";
export const ChatInput = ({ onSendMessage, isLoading, disabled }) => {
  const { t } = useTranslation();
  const [input, setInput] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    if (!disabled && !isLoading) {
      inputRef.current?.focus();
    }
  }, [disabled, isLoading]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const trimmedInput = sanitizeInput(input);

    if (!trimmedInput || isLoading || disabled) {
      return;
    }

    try {
      await onSendMessage(trimmedInput);
      setInput("");
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  const canSend = input.trim().length > 0 && !isLoading && !disabled;

  return (
    <form onSubmit={handleSubmit} className="gpc-input-container">
      <input
        ref={inputRef}
        type="text"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={t("chat.placeholder")}
        disabled={isLoading || disabled}
        maxLength={INPUT_LIMITS.MAX_LENGTH}
        className="gpc-input"
        aria-label={t("chat.placeholder")}
        aria-describedby="chat-input-help"
      />

      <button
        type="submit"
        disabled={!canSend}
        className="gpc-send-button"
        aria-label={t("chat.send")}
        title={t("chat.send")}
      >
        {isLoading ? (
          <span className="gpc-spinner" />
        ) : (
          <Send className="gpc-icon" />
        )}
      </button>

      <span id="chat-input-help" className="gpc-sr-only">
        {t("chat.placeholder")}. Máximo {INPUT_LIMITS.MAX_LENGTH} caracteres.
      </span>
    </form>
  );
};